import { render, staticRenderFns } from "./wenjian.vue?vue&type=template&id=f3e4dbfc&scoped=true"
import script from "./wenjian.vue?vue&type=script&lang=ts"
export * from "./wenjian.vue?vue&type=script&lang=ts"
import style0 from "./wenjian.vue?vue&type=style&index=0&id=f3e4dbfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e4dbfc",
  null
  
)

export default component.exports